import React, { Component } from 'react';
import { getQueryString } from 'utils';
// import  './invite.less'

export default class Privacy extends Component {
    constructor(props) {
        super(props);

        this.state = {
            type: getQueryString('type')
        }
    }

    setName = () => {
        const { type } = this.state;
		
		if (!type) {
			//return '呼呼收音机'
			let url = 'http://a.huhustory.com/Stat/watch/huawei/privacy.html'
			window.location.href = url;		
		} else {
			//return name[type]
			let url = 'http://a.huhustory.com/Stat/watch/huawei/privacy_etxgs.html'
			window.location.href = url;	
		}		

        let name = {
            'etxgs': '儿童学古诗',
            'etxcy': '儿童学成语',
            'yyqmeg': '英语启蒙儿歌',
            'klxcy': '快乐学成语',
            'cygs': '成语故事',
            'nppxgshd': '奶泡泡学古诗HD',
        }
        // console.log(name[type]);

        if (!type) {
            return '呼呼收音机'
        } else {
            return name[type]
        }
    }

    setUrl = () => {
        const { type } = this.state;

        let url = {
            'etxgs': 'https://m.huhustory.com/?source=etxgs',
            'etxcy': 'https://m.huhustory.com/?source=etxcy',
            'yyqmeg': 'https://m.huhustory.com/etxeg',
        }
        // console.log(name[type]);

        if (!type) {
            return 'https://m.huhustory.com'
        } else {
            return url[type]
        }
    }

    render() {
        return (<div>
            <h3 style={{
                textAlign: 'center',
                fontWeight: 'bold',
                padding: '50px 0 20px',

                color: '#000'
            }}>{this.setName()}隐私政策</h3>
            <div style={{
                paddingBottom: "20px",
                fontSize: '14px',
                fontFamily: '宋体',
                padding: '0 15px',
                color: '#000',
                overflow: 'hidden'

            }}>

                生效日期: 2023年05月3日<br />
                更新日期: 2023年05月3日<br /><br />

                关于我们<br /><br />
                {this.setName()}的运营主体杭州叽里咕噜文化传播有限公司（以下简称“我们”），成立于 2018年7月11日，注册地址：浙江省杭州市拱墅区祥盛路12号501室，常用办公地址：浙江省杭州市拱墅区祥园路28号11号楼，联系电话：0571-56716607。如您想更详细地了解我们的公司、平台，你可以通过本政策提供的联系方式与我们联系。我们将按照法律法规要求和业界成熟的安全标准，采取相应的安全保护措施来保护用户（以下简称“您”）的个人信息，我们深知保护您的个人信息对我们提供服务具有重要意义。我们希望通过本隐私政策向您清晰地介绍在使用我们的产品/服务时，我们如何处理您的个人信息，以及我们为您提供的访问、更正、删除和保护这些信息的方式。<br /><br />

                本政策将帮助您了解以下内容：<br /><br />

                一、个人信息定义<br /><br />

                二、我们如何收集和使用您的个人信息<br /><br />

                三、我们如何使用 Cookie 和同类技术<br /><br />

                四、我们如何共享、公开披露您的个人信息<br /><br />

                五、我们如何保存和保护您的个人信息<br /><br />

                六、您如何管理您的个人信息<br /><br />

                七、未成年人的个人信息保护<br /><br />

                八、通知和修订<br /><br />

                九、联系方式<br /><br />

                <h3 style={{ fontSize: '15px', textAlign: 'center', fontWeight: 'bold', color: '#000', margin: '0' }}>特别提示</h3>
                请您在使用我们提供的各项产品/服务前，仔细阅读并充分理解本《隐私政策》（特别是加粗请您特别关注的条款）并作出相应选择。一旦您使用或继续使用我们的产品/服务时，即意味着您同意我们按照本隐私政策处理您的相关信息。<br />
                如对本隐私政策有任何疑问，您可以通过本隐私政策“联系方式”中提供的方式与我们联系） 。<br />
                请您注意，本政策不适用于您通过我们的产品/服务而接入的其他第三方产品/服务，具体规定请参照该第三方的隐私政策或类似声明。<br /><br />

                一、个人信息定义：<br /><br />

                1、个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。本隐私政策中可能涉及到的个人信息包括但不限于：<br />
                （1）个人基本信息（包括姓名、电话号码、性别、住址、生日等）；<br />
                （2）个人身份信息（包括身份证、军官证、护照、驾驶证等）；<br />
                （3）网络身份信息（包括系统账号、IP地址、邮箱地址及与前述有关的密码、口令、口令保护答案）；<br />
                （4）个人财产信息（包括银行账号、交易和消费记录，以及虚拟财产信息等）；<br />
                （5）个人上网记录（包括网站浏览记录、点击记录等）；<br />
                （6）个人设备信息（包括唯一设备识别码等描述个人常用设备基本情况的信息）；<br />
                （7）个人位置信息（包括行踪轨迹、精准定位信息等）。<br />
                （8）个人手机相册（包括手机相册存储的相片、音频、视频及其他文件，也包括系统调用个人手机相机、麦克风录制生成的内容）。<br /><br />

                2、个人敏感信息：是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。本隐私政策中可能涉及到的个人敏感信息包括：<br />
                （1）个人身份认证信息（包括身份证、军官证、护照、驾驶证、学生证等）；<br />
                （2）个人财产信息（银行账号、交易和消费记录，以及虚拟财产信息等）；<br />
                （3）其他信息（行踪轨迹、通讯录信息、精准定位信息等）；<br />
                （4）14周岁以下的儿童信息。<br /><br />

                二、我们如何收集和使用您的个人信息<br /><br />

                在您使用我们的产品/服务时，您需要/可以选择授权我们收集和使用个人信息的场景包括：<br /><br />

                1、您无需向我们提供您的个人信息，就可以使用我们的基本功能。<br /><br />

                2、为了向您提供我们产品/服务的附加功能，您可以选择授权我们收集、使用信息的情形，如您拒绝提供前述信息，您将无法正常使用相关附加功能或无法实现我们更好的产品/服务效果，但并不会影响您正常使用我们产品/服务的基本功能。<br /><br />

                （一）您需要授权我们收集和使用个人信息的场景<br /><br />

                我们会遵循正当、合法、必要的原则，出于本政策所述的下列目的收集和使用您的个人信息。<br /><br />
				1.IMEI，IMSI，Android_id，MAC地址：<br /><br />
				为保障您正常使用我们的服务，维护app功能的正常运行，根据您的设备终端和网络状态优化产品性能，提升您的使用体验并保障您的账号安全，我们会收集您的设备名称、设备类型、设备型号和版本、操作系统、系统属性、IP地址、运营商信息、Wi-Fi状态/参数，设备识别符（如IMEI、IMSI、MAC地址、Android ID、硬件序列号）、应用ID、网络类型、传感器信息等信息。请注意，单独的传感器信息不属于个人信息，我们也不会将传感器信息用于其他用途。<br/><br/>
				为了保障软件与服务的安全运行、运营的质量及效率，我们会收集你的设备的硬件型号、操作系统版本号、设备标识符（Android如IMEI、AndroidID、OAID、IMSI、ICCID、MEID、硬件序列号）、网络设备硬件地址（MAC地址）、IP 地址、WLAN接入点（如SSID，BSSID）、蓝牙（Bluetooth）、基站、软件版本号、网络接入方式、类型、状态、网络质量数据、操作、使用、服务日志、设备传感器数据。<br/><br/>
				为识别您的设备ID并预防恶意程序、提高服务安全性、保障运营质量及效率，我们会收集您的设备信息（包括IMEI、MEID、Android ID、IMSI、GUID、MAC地址）、您安装的应用信息或运行中的进程信息。<br/><br/>
				2.已安装应用列表:<br /><br />
				您在使用我们的服务时，若您想分享您喜欢的内容至第三方App，我们需要判断是否安装了第三方App，以便为您提供正确的分享功能。
			
				<br /><br />
				3.IP地址:
				
				<br /><br />
				为了保障软件与服务的安全运行、运营的质量及效率，我们会收集你的硬件型号、操作系统版本号、设备标识符（Android如IMEI、AndroidID、OAID、IMSI、ICCID、GAID、MEID，iOS如IDFV、IDFA；不同的标识符在有效期、是否可由用户重置以及获取方式方面会有所不同）、网络设备硬件地址（MAC地址）、硬件序列号、IP 地址、WLAN接入点（如SSID，BSSID）、蓝牙（Bluetooth）、基站、软件版本号、网络接入方式、类型、状态、网络质量数据、操作、使用、服务日志、传感器信息等数据。
				
				<br /><br />
				为就近分配服务器，提高用户整体使用和访问速度，我们将收集您的IP地址。
				
				
				

                4、注册新用户<br /><br />

                为遵守法律法规的要求，以及向您提供完善的服务，在您注册成为{this.setName()}用户时，您需要至少提供手机号码以创建{this.setName()}账号；如果您仅需使用浏览功能，您无需注册成为我们的用户。<br /><br />

                如您选择授权使用第三方账号登录时，我们会从第三方获取您共享的账号信息（如头像、昵称、地区、性别等信息）与您的{this.setName()}账号进行绑定用于快捷登录，我们会依据与第三方的约定，在符合相关法规的前提下，使用您的个人信息。<br /><br />
				
               

                5、为您提供预订、下单、订单管理功能<br /><br />

                您在{this.setName()}上预订/下单内容产品、实物商品等服务时，您需要根据所选择的服务类型提供联系人信息（姓名、性别、电话号码等）、地址信息（收件人姓名、地址、联系方式等）等。<br /><br />

                为向您展示您账户的订单信息，及便于您对订单信息的管理，我们会收集您在使用我们服务过程中产生的订单信息。您在{this.setName()}上生成的订单中，将可能包含您的身份信息、联络信息、支付信息等，这些都属于敏感信息，请您谨慎向他人展示或对外提供，我们也将会在展示订单信息时，在保证信息可用性的基础上尽量去标识化处理。<br /><br />

               6、为您提供收藏、关注、分享、赠送、推荐、活动类功能<br /><br />

                为了获得更轻松的访问体验，与好友及第三方进行分享，您可以收藏/关注/分享您感兴趣内容，也可以通过功能组件向第三方进行信息分享，我们可能会收集您在使用上述功能中产生的日志信息，用于在个人主页中向您展示、实现在线管理、发起共享等。 <br /><br />

                您同意在您主动参与拼团、分享、赠送等活动中，参与方均可以通过活动页面获得相对方的头像、用户名等基础信息。如果您主动参加平台抽奖、奖励类活动，您同意平台有权基于公平原则将获奖者头像、用户名向平台所有参与用户做公示。<br /><br />

                7、为您发表图片、影音作品内容<br /><br />

                您可以依自身意愿，自主选择参加本平台上的活动，或者单独作为创作者发表图片、影音作品，或者通过评论发表图片、影音作品。我们有权限依据您的授权，读取您手机相册内容并上传至{this.setName()}，并有权依您的授权调用您的相机、麦克风功能制作照片、影音作品。<br /><br />

               

                8、为您提供写点评、攻略等信息发布功能<br /><br />

                您在{this.setName()}上主动对内容作品服务进行评价或发布其他内容（如分享心情、状态、签到、攻略等信息）时，我们将收集您发布的信息，并展示您的昵称、头像和发布内容等。如您选择以匿名方式发布评价信息时，我们将不展示您的昵称、头像。<br /><br />

                9、帮助您完成支付<br /><br />

                您在{this.setName()}上进行订单支付时，您可以选择{this.setName()}的第三方合作机构（如微信支付、Apple Pay、支付宝等合作方）所提供的服务进行支付。我们需要收集您的{this.setName()}订单信息、对账信息及其他法律要求的必要信息并与这些合作机构共享，以确认您的支付指令并帮助您完成支付。如您委托第三方完成支付，你确保已经得到第三方的同意并授权我们获知第三方的上述信息。<br /><br />

                10、为您提供客服和售后服务<br /><br />

                当您与我们的客服取得联系时，我们的系统可能会记录您与客服之间的通讯记录，以及使用您的账号信息以便核验身份；当您需要我们提供与您订单相关的客户服务时，我们可能会查询您的相关订单信息以便给予您适当的帮助和处理；当您需要客服协助您修改有关信息时，您可能还需要提供上述信息外的其他信息以便完成修改。<br /><br />

                11、为您提供安全保障<br /><br />

                为了保障您的账号安全、交易安全以及系统运行安全，满足法律法规和我们协议规则的相关要求，在您使用我们的产品/服务过程中，经您授权我们会获取您的设备信息，包括您使用的设备属性、设备编号、电信运营商等设备信息。<br />
                为提高您使用我们提供的服务的安全性，我们可能会使用或整合您的个人信息以及我们的关联方、合作伙伴取得您授权或者依法共享的信息，根据您的使用习惯和常用软件信息等来综合判断您的账号及交易风险，包括验证身份，预防、发现、调查可能存在的欺诈、网络病毒、网络攻击等安全风险以及违反我们或关联方协议、政策或规则等行为，以保护您、其他用户、我们或关联方的合法权益，并记录一些我们认为有风险的链接(“URL”)。<br /><br />

                12、我们可能间接收集的个人信息<br /><br />

                为完成身份核验，保障账号安全，确认交易状态及为您提供售后与争议解决等目的，经您授权后我们可能会从第三方获取您的个人信息（例如通过您选择的交易对象和交易直接涉及的第三方信息系统、支付机构等收集与交易进度相关的您的交易等信息，以便于我们处理您的订单并保证服务的顺利完成，或者更好地预防诈骗、刷单等恶意行为）。我们会依据法律法规的要求以及与第三方的约定，经您授权后向{this.setName()}的关联方、合作伙伴获得您的有关信息，并对其信息来源的合法性进行确认后使用您的这些信息。<br /><br />

                
				
				
				
				（二）您可以选择授权我们收集和使用个人信息的场景<br /><br />

                您可以选择使用我们提供的拓展功能，我们会在符合法律规定并根据您具体授权的情况下收集并使用如下信息。这类信息将在您选择的具体功能和业务场景中进行收集，如果您不提供这些信息，不会影响您使用{this.setName()}的基本功能。<br /><br />

                1、基于相机授权的拓展业务<br /><br />

                您可以选择开启系统的相机权限，通过使用拍照等功能授权{this.setName()}访问您的相机，以便于您通过拍摄照片等方式发布内容，或者向用户提供视听服务。如果您需要录制并发布有声视听作品时，您还需开启麦克风权限。我们会收集您上传发布的上述信息，此项功能您可以在系统权限中关闭，一旦关闭您将可能无无法通过拍摄图片等方式，但不会影响您享受{this.setName()}服务的基本功能。<br /><br />

                2、基于相册授权的拓展功能<br /><br />

                您可以选择开启系统的相册权限，通过主动上传图片、视频等方式授权我们访问您的相册，以便于您通过上传照片或上传视频等方式发布内容。我们会收集您选择上传发布的上述信息，此项功能您可以在系统权限中关闭，一旦关闭您将可能无法通过上传图片、视频等方式进行更换头像、发布带图点评等，但不会影响您享受{this.setName()}服务的基本功能。<br /><br />

                3、基于麦克风授权的拓展功能<br /><br />

                您可以选择开启系统的麦克风权限，使用语音技术来实现语音搜索、录制音频等语音交互功能。此项功能您可以在系统权限中关闭，一旦关闭您将可能无法实现在线语音交互功能，但不会影响您享受{this.setName()}服务的基本功能。<br /><br />

                4、基于通话状态的拓展功能<br /><br />

                您可以选择开启平台及系统的读取通话状态权限，我们将在不影响您正常通话状态的情况下自动暂停视听节目的播放。此项功能您可以在系统权限中关闭，一旦关闭您将可能无法在正常收听平台视听节目的时候得知您的来电，但不会影响您享受{this.setName()}服务的基本功能。<br /><br />

               
                （三）征得同意的例外<br /><br />

                请您知悉，以下情形中，我们收集、使用个人信息无需征得您的授权同意：<br />
                1、与国家安全、国防安全有关的；<br />
                2、与公共安全、公共卫生、重大公共利益有关的；<br />
                3、与犯罪侦查、起诉、审判和判决执行等有关的；<br />
                4、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；<br />
                5、所收集的个人信息是个人信息主体自行向社会公众公开的；<br />
                6、从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；<br />
                7、学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；<br />
                8、法律法规规定的其他情形。<br /><br />

                （四）个人信息的使用规则<br /><br />

                为满足您的需求，维护、改进我们的产品或服务质量，我们会在符合法律规定并根据您具体授权的情况下使用如下信息：<br /><br />

               
                1、我们可能会收集您在参与产品/服务调查时主动向我们提供的信息，以便于您追踪订单情况、发起用户投诉以及我们优化客户服务的质量与流程。<br /><br />

                2、我们可能将业务中收集的个人信息用于统计分析和改进运营，将已经去标识化无法识别您身份且不能复原的信息用于建立数据库并进行商业化利用。例如通过您所在的位置、偏好等进行统计分析，从而改进我们的产品、服务或营销计划；又如为改进我们系统而进行的技术改造、网络维护、故障排除、内部政策与流程制定、生成内部报告等。<br /><br />

                三、我们如何使用Cookie和同类技术<br /><br />

                为确保网站正常高效运转、为您获得更轻松的访问体验、我们会在您的设备终端/系统上存储名为 Cookie的小数据文件。我们不会将 Cookie用于本隐私政策所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookie。您可以清除计算机或移动设备上保存的所有 Cookie，您有权接受或拒绝Cookie。大多数浏览器会自动接受Cookie，但您通常可根据自己的需要来修改浏览器的设置以拒绝Cookie；另外，您也可以清除软件内保存的所有Cookie。但您可能因此无法完全体验我们某些便捷性和安全性的服务功能。<br /><br />

                四、我们如何共享、公开披露您的个人信息<br /><br />

                （一）共享<br /><br />

                我们不会与{this.setName()}以外的任何公司、组织和个人共享您的个人信息，但以下情况除外：<br /><br />

                1、获得您明确同意或授权的共享。<br /><br />

                2、基于法定情形下：根据法律法规的规定、诉讼争议解决需要，或行政、司法等有权机关依法提出的要求。<br /><br />

                3、与关联公司共享：为向您提供一致化服务以及便于您进行统一管理，我们可能会将您的个人信息与我们的关联公司共享。但我们只会共享必要的个人信息，如果我们共享您的个人敏感信息或者关联方改变个人信息的使用目的，将再次征求您的授权同意。<br /><br />

                4、与合作伙伴分享：我们可能会向业务合作伙伴共享为您提供服务所必要的订单信息、账户信息、支付信息等。我们的业务合作伙伴包括以下类型：<br /><br />

                （1）数据统计、数据分析服务类的授权合作伙伴。为维护/改进我们的产品/服务、为您提供更好的内容，我们可能会接入提供该服务的指定合作伙伴（友盟、极光推送），以分析您使用我们的服务情况。<br /><br />

                （2）供应商/服务提供商。仅为实现本政策中声明的目的，我们的某些服务将由业务合作伙伴提供。以保障为您提供的服务顺利完成，我们可能会将您的个人信息共享给上述合作伙伴，包括配送业务、技术服务、支付服务、金融业务等。其中可能包括您的联络信息、订单信息、支付信息、地址信息等，以保障为您提供的服务顺利完成。<br /><br />

                （3）第三方商家。我们必须将您的订单信息、必要交易信息与第三方商家共享，以便其向您提供商品、服务及售后等。<br /><br />

                请您放心，除得到您的明确同意，我们不会将可以联系或识别您身份的个人信息与授权合作伙伴共享，我们将能够识别您身份的个人信息进行去标识化处理，以便授权合作伙伴无法识别您的具体身份。<br /><br />

                呼呼收音机产品中包含我们授权的合作伙伴提供的SDK插件。当您在呼呼收音机中使用该授权合作伙伴提供的相关服务，该等服务插件将收集和处理您的相关个人信息，详见附件：《呼呼收音机APP涉及个人信息传输的SDK情况表》。我们会对授权合作伙伴获取有关信息的应用程序接口（API）、软件工具开发包（SDK）进行严格的安全检测，审慎评估服务提供商使用您个人信息的目的，对这些合作方的安全保障能力进行综合评估，并与授权合作伙伴通过签署协议的方式约定严格的数据保护措施，要求其按照我们的委托目的、服务说明以及其他任何相关的保密和安全措施来处理个人信息。我们强烈建议您在使用任何第三方SDK服务前先行查看并了解其隐私条款。<br /><br />

                5、基于协议约定：依据您与我们签署的相关协议（包括在线签署的电子协议及平台规则）或法律文件，有必要向第三方共享时。<br /><br />

                6、基于合理商业习惯：例如与第三方共享联合营销活动中的中奖信息，以便第三方能及时向您发放奖品；或者在我们计划与其他公司进行资本市场活动(包括但不限于IPO，债券发行)接受尽职调查时。<br /><br />

                7、基于学术研究；例如为科研机构开展统计或学术研究之必要。<br /><br />

                8、基于符合法律法规的社会公共利益等。<br /><br />

                请您知悉，我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，对我们仅为实现本政策中声明的目的与之共享个人信息的公司、组织和个人，我们会与其签署严格的信息保护和保密协定，要求他们遵守协议并采取相关的安全措施来保护您的个人信息。<br /><br />

                （二）公开披露<br /><br />

                我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才可能公开披露您的个人信息：<br /><br />

                1、根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息；<br /><br />

                2、根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。<br /><br />

                请注意，您在使用我们服务时自愿发布甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息，如您的交易信息，以及您在评价时选择上传包含个人信息的文字、图片或视频等各种形式的信息。请您在使用我们的服务时更加谨慎地考虑，是否要发布甚至公开分享相关信息。<br /><br />

                （三）共享、公开披露个人信息时事先征得授权同意的例外<br /><br />

                以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：<br />
                1、与国家安全、国防安全有关的；<br />
                2、与公共安全、公共卫生、重大公共利益有关的；<br />
                3、与犯罪侦查、起诉、审判和判决执行等有关的；<br />
                4、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；<br />
                5、其他维护公共利益的情形，例如您的信用评价信息需要被公开/共享；<br />
                6、您自行向社会公众公开的个人信息；<br /><br />

                根据法律规定，共享、公开披露经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，我们对此类数据的处理将无需另行向您通知并征得您的同意。<br /><br />

                五、我们如何保存和保护您的个人信息<br /><br />

                （一）个人信息的保存<br /><br />

                1、保存期限：除非依据法律法规或双方约定，我们仅会在实现目的所必需的最短时间内留存您的相关个人信息。在您主动注销账号时，我们将根据法律法规的要求尽快删除您的个人信息或匿名化处理。<br /><br />

                2、保存地域：我们在中华人民共和国境内收集和产生的个人信息，将存储在中国境内，目前我们暂时不存在跨境存储您的个人信息或向境外提供个人信息的场景。如需跨境存储或向境外提供个人信息的，我们会单独向您明确告知（包括出境的目的、接收方、使用方式与范围、使用内容、安全保障措施、安全风险）并再次征得您的授权同意。<br /><br />

                3、终止运营：如果发生终止运营等情形，我们将会至少提前30天通知您，并在终止运营后对您的个人信息进行删除或匿名化处理。<br /><br />

                （二）个人信息的保护措施<br /><br />

                1、数据安全措施<br /><br />

                为保障您的信息安全，我们努力采取各种符合业界标准的物理、电子和管理方面的安全措施来保护您的个人信息，建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范个人信息的存储和使用。{this.setName()}通过信息接触者保密协议、监控和审计机制来对数据进行全面安全控制。防止您的个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。例如在您的浏览器与“服务”之间交换数据(如信用卡信息)时采用SSL加密保护技术;同时对网站本身提供https安全浏览方式;使用加密技术确保数据的保密性;使用受信赖的保护机制防止数据遭到恶意攻击;部署访问控制机制，确保只有授权人员才可访问个人信息;以及举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。<br /><br />

                2、请您知悉并理解，互联网并非绝对安全的环境，我们强烈建议您通过安全方式、使用复杂密码，协助我们保证您的账号安全。如您发现自己的个人信息泄密，尤其是您的账户或密码发生泄露，请您立即根据本隐私政策中提供的联系方式联络我们，以便我们采取相应措施。<br /><br />

                3、安全事件<br /><br />

                在不幸发生个人信息安全事件后，我们会立即成立专项应急小组，启动应急预案，防止安全事件扩大，并按照法律法规的要求及时向您告知:安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。<br /><br />

                六、您如何管理您的个人信息<br /><br />

                您对您的个人信息享有以下权利:<br /><br />

                （一）您有权访问、更正、删除您的个人信息，法律法规规定的例外情况除外。您可以通过以下方式管理您的信息:<br /><br />

                账户信息——您可以访问、更正您账户中的个人资料及账号信息（身份认证信息除外）、支付信息、账号绑定信息等，也可以更改您的密码、添加安全信息或进行第三方账号和银行卡的解绑等，您可以通过访问网页及App在设置中执行此类操作。<br /><br />

                搜索浏览信息——您可以在{this.setName()}网页/App中访问或清除您的搜索历史记录、查看和修改以及管理其他数据。<br /><br />

                订单信息——您可以通过访问个人中心页面查看您的所有已经完成、待付款、待售后、待评价的订单。您可以选择删除已完成的订单信息，但这样可能导致我们无法根据您的购买信息而准确提供相应的售后服务。<br /><br />

                评论信息——您可以通过访问{this.setName()}网页/App页面作品页面访问、更正、清除您的评论内容。<br /><br />

                如果您无法通过上述链接管理这些个人信息，您可以随时通过本隐私政策中提供的反馈方式联系我们。我们将在15天内回复您的访问请求。<br /><br />

                （二）改变您授权同意的范围或撤回授权<br /><br />

                您可以通过在{this.setName()}网站/App中删除信息、更改隐私设置或者在系统中关闭设备权限功能等方式改变同意范围或撤回您的授权。<br /><br />

                请您理解，当您执行上述操作后，我们将无法继续为您提供撤回同意或授权所对应的服务，但不会影响此前基于您的授权已经开展的个人信息处理。<br /><br />

                （三）注销账户<br /><br />

                您有权注销您的{this.setName()}账户，如您需要注销的话，您可通过客户端相应流程/途径注销，查找路径如下“我的-设置-注销账号”。

                我们承诺不在用户注销环节设置不合理障碍，不向提出注销要求的用户提额外要求；收到注销账号请求后，一般会在流程中即时完成注销，如遇特殊情况最多7个工作日内完成注销。注销账户之后，会立即生效，我们将停止为您提供服务，在你注销{this.setName()}的相关服务，你将无法再以此账号登录和使用{this.setName()}的相关的服务，该账号在{this.setName()}的服务使用期间已产生的但未消耗完毕的权益及未来的逾期利益的权益将全部清除，该账号下的内容，信息，数据，记录将会被清除（但法律法规另有规定或者监管部门另有要求的除外），同时{this.setName()}账号一旦注销完成，将无法修复。对于已注销的账号及账号相关信息，我们会依据适用法律法规的要求进行完全删除。

                如果您无法通过上述方式访问、更正或删除您的个人信息以及注销账号，或者如果您认为我们存在违反法律的规定收集、使用您个人信息的情形，您可以通过我们的客服或通过本隐私政策提供的其他方式与我们取得联系。为了保障安全，我们可能需要您提供相应方式证明您的身份和请求的正当性，我们将在收到您反馈并验证您的身份后的30-90天内答复您的请求。

                （四）拒绝接受定向推送及营销信息<br /><br />

                拒绝营销——您可以通过回复退订方式退订我们发送给您的营销短信。<br /><br />

                七、未成年人的个人信息保护<br /><br />

                {this.setName()}非常重视对未成年人个人信息的保护。将严格按照国家法律法规要求在未成年人使用服务时提供相应的保护, 如您是未成年人的，需要您的父母或其他监护人同意您使用本应用并同意相关应用的服务条款，并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息。<br /><br />

               父母或其他监护人也应采取适当的预防措施来保护未成年人，包括监督其对本应用的使用。 <br/><br/>
			   特别地，如果您是儿童（不满十四周岁的未成年人），在您使用我们的服务前，请务必通知您的父母或其他监护人一起仔细阅读本声明以及儿童隐私保护声明，并在您的父母或其他监护人同意或指导后，使用我们的服务或向我们提供信息。如果您是儿童的父母或其他监护人，请确保您监护的儿童在您的同意或指导下使用我们的服务和向我们提供信息。<br /><br />
				
				对于经父母或监护人同意使用我们的产品或服务而收集未成年人个人信息的情况，我们只会在法律法规允许、父母或监护人明确同意的情况下使用、共享、转让或披露此信息。<br /><br />

				我们非常重视儿童保护，并采取合理可行的措施保护儿童的个人信息和身心健康：
				
				（一）我们默认保护儿童隐私，不会向儿童提供个性化广告、个性化推荐的运营活动等。
				
				（二）我们对提供的内容做了分层分类，您可以为孩子选择合适的学习阶段，我们会根据您的选择呈现适合的内容。
				
				（三）我们会加密存储包括儿童帐号在内的用户标识相关个人信息，确保信息安全。我们存储的儿童个人信息，不会超过实现其收集、使用目的所必需的期限。
				为此我们专门制定了<a href="http://m1.huhustory.com/simple/children">呼呼收音机儿童个人信息保护规则与监护人须知</a>,请查看
		
				

                八、通知和修订<br /><br />

                为给您提供更好的服务，我们的业务将不时变化，本隐私政策也将随之调整。未经您明确同意，我们不会削减您依据本隐私政策所应享有的权利。我们会通过在我们网站、移动端上发出更新版本或以其他方式提醒您相关内容的更新，也请您访问我们以便及时了解最新的隐私政策。在前述情况下，若您继续使用我们的服务，即表示同意接受修订后的本政策并受之约束。<br /><br />

                九 涉及用户信息使用的SDK相关情况如下:<br /><br />
                1.友盟统计SDK<br /><br />
                服务类型: 统计分析<br /><br />
                SDK描述: 友盟统计是提供给开发者方便使用的数据分析服务SDK<br /><br />
                SDK使用业务: 数据分析，软件缺陷分析<br /><br />
				收集个人信息类型：设备信息（IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/IP地址/SIM 卡 IMSI 信息等）<br /><br />
                SDK官网地址: https://developer.umeng.com/sdk<br /><br />
                SDK隐私说明地址: https://www.umeng.com/page/policy
				<br /><br />
                使用目的/理由: 用户产品APP数据统计分析，用于用户标识及基于此的数据分析服务<br /><br />
				

                2.微信开放平台SDK<br /><br />
                SDK类型: 工具<br /><br />
                SDK描述: 微信登录,微信支付，微信扫码支付,收藏,分享<br /><br />
                SDK使用业务: 微信登录和支付以及微信分享<br /><br />
                SDK所需用户信息字段: 软件安装列表,设备型号,Mac地址,IMEI,IMSI,系统版本,手机型号<br /><br />
                SDK官网地址: https://open.weixin.qq.com<br /><br />
                SDK微信开放平台开发者服务协议: https://open.weixin.qq.com/cgi-bin/frame?t=news/protocol_developer_tmpl<br /><br />
                使用目的/理由: 快捷登录, 在APP内支付<br /><br />

                3.支付宝支付SDK<br /><br />
                SDK类型: 工具<br /><br />
                SDK描述: 支付宝支付功能<br /><br />
                SDK使用业务: 支付宝支付<br /><br />
                SDK所需用户信息字段: IMEI/IMSI,SIM卡序列号/Mac地址网络信息以及地理位置信息<br /><br />
                SDK官网地址: https://open.alipay.com/platform/home.htm<br /><br />
                SDK隐私说明地址: https://opendocs.alipay.com/open/009ys9<br /><br />
                使用目的/理由: 商品支付<br /><br />

                4.极光推送SDK<br /><br />
                SDK类型: 工具<br /><br />
                SDK描述:JPush是经过考验的大规模App推送平台,每天推送消息数量级为数百亿条.开发者集成SDK后,可以通过调用API推送消息<br /><br />
                SDK使用业务场景: 极光厂商渠道推送,消息通知<br /><br />
                SDK需要用户的信息字段:设备标识符(IMEI,Android ID,MAC,OAID相关信息,通知开关状态,软件列表信息),设备参数及系统信息(设备类型,设备型号,操作系统及硬件相关信息),网络信息:IP地址,WiFi信息,基站信息<br /><br />
                SDK官网地址：https://docs.jiguang.cn/jpush/guideline/intro/<br /><br />
                SDK隐私说明地址：https://docs.jiguang.cn/compliance_guide/compliance_and_security_policy_interpretation/compliance_and_security_policy_interpretation/<br /><br />

                5.乐播投屏SDK<br /><br />
                SDK类型: 工具<br /><br />
                SDK描述：乐播投屏发送端SDK，接入后，能让您的APP轻松拥有投屏与镜像的能力，从而在满足用户需求的同时，也将您的内容分发到大屏上。<br /><br />
                SDK使用业务场景：视频投屏<br /><br />
                SDK需要用户的信息字段：(IMEI/OAID/设备型号,操作系统版本)，设备传感器信息(如手机角速度，手机加速度)，网络信息(常用登录IP地址)<br /><br />
                SDK官网地址：https://www.lebo.cn/index<br /><br />
                SDK隐私说明地址：https://www.lebo.cn/privacy.jsp<br /><br />
                使用目的/理由：家庭使用视频投屏到大屏端，分析设备机型投屏质量提升产品质量，改善投屏体验。<br /><br />
                    
                6.腾讯浏览服务SDK (SDK: TencentSmtt)<br /><br />
                SDK类型: 移动端webview体验的整套解决方案<br /><br />
                SDK描述：腾讯浏览服务是致力于优化移动端webview体验的整套解决方案。该方案由SDK、手机QQ浏览器X5内核和X5云端服务组成，解决移动端webview使用过程中出现的一切问题，优化用户的浏览体验。同时，腾讯还将持续提供后续的更新和优化，为开发者提供最新最优秀的功能和服务。<br /><br />
                SDK使用业务场景：网页的高可靠性浏览以及稳定性展示所必需<br /><br />
                SDK需要用户的信息字段：DEVICEID/IMSI ，androidID，MAC，网络信息<br /><br />
                SDK官网地址：https://x5.tencent.com/tbs/index.html<br /><br />
                SDK隐私说明地址：https://x5.tencent.com/docs/privacy.html<br /><br />
                使用目的/理由：  用于设备标识，浏览器内核升级和禁用细化控制；通过去标识化、加密传输和处理的安全处理方式，为用户提供webview网页的可靠稳定展示<br /><br />

                7.小米联运SDK<br /><br />
                SDK类型: 工具   <br /><br />
                SDK描述：应用联运是针对应用推出的内容购买（IAP）合作模式，开发者只需要集成应用联运SDK，就可以在小米手机使用小米支付方式支付。<br /><br />
                SDK使用业务场景：小米支付<br /><br />
                SDK需要用户的信息字段：（IMEI、OAID/设备型号，操作系统版本）、设备传感器信息（手机角速度、手机加速度）、  网络信息（常用登录IP地址）<br /><br />
                SDK官网地址：https://dev.mi.com/console/<br /><br />
                SDK隐私说明地址：https://privacy.mi.com/miaccount/zh_CN   <br /><br />
                使用目的/理由：在小米手机上使用小米应用渠道进行支付 <br /><br />

                8.vivo联运SDK <br /><br />
                SDK类型: 工具<br /><br />
                SDK描述：vivo支付SDK是vivo为合作伙伴提供的支付功能插件（包括支付宝、微信、银联支付，QQ钱包），适用于android平台的所有版本。<br /><br />
                SDK使用业务场景：vivo支付（内置支付宝， 微信，银联支付，QQ钱包）<br /><br />
                SDK需要用户的信息字段：（IMEI、OAID、DEVICEID/设备型号，操作系统版本）、网络信息（常用登录IP地址）<br /><br />
                SDK官网地址：https://dev.vivo.com.cn/documentCenter/doc/135<br /><br />
                SDK隐私说明地址：https://dev.vivo.com.cn/documentCenter/doc/26 <br /><br />
                使用目的/理由：在vivo手机上使用vivo应用渠道进行支付<br /><br />

                9.华为联运SDK   <br /><br />
                SDK类型: 工具   <br /><br />
                SDK描述：联运服务是指华为和开发者在华为应用市场联合运营应用，并进行分成的合作服务。 联运服务通过接入HMS Core的能力来实现联运，涉及的服务包括 华为账号登录服务，应用内支付服务，华为分析服务，应用升级，
                HMS Core的其他服务等。<br /><br />
                SDK使用业务场景： 华为支付<br /><br />
                SDK需要用户的信息字段：（IMEI、OAID、DEVICEID/设备型号，操作系统版本）、网络信息（常用登录IP地址）<br /><br />
                SDK官网地址：https://developer.huawei.com/consumer/cn/doc/distribution/service/hag_joint_operation<br /><br />
                SDK隐私说明地址：https://dev.vivo.com.cn/documentCenter/doc/26    <br /><br />
                使用目的/理由：在华为手机上使用华为应用渠道进行支付<br /><br />

                10. Fresco<br /><br />
                SDK类型: 框架   <br /><br />
                SDK描述：Fresco是FaceBook推出的一个Android开源图片管理框架，它提供了图片下载、渐进式加载、内存管理等功能， 很大程度上把程序员从繁琐的图片管理工作中解放了出来   <br /><br />
                SDK使用业务场景： 图片的加载、处理、绘制、展示
                SDK官网地址：https://github.com/facebook/fresco<br /><br />
                使用目的/理由：处理图片，缓存图片<br /><br />

                11.AndroidUtilCode<br /><br />
                SDK类型: 框架   <br /><br />
                SDK描述：AndroidUtilCode是一个强大易用的安卓工具类库，它合理地封装了安卓开发中常用的函数，具有完善的Demo 和单元测试，利用其封装好的 APIs 可以大大提高开发效率，如今它主要包括两部分模块，其一是主工具类模块：utilcode，其中的工具类是开发中常用到的；其二是子工具类模块：subutil，它包含的工具类并不是很常用，它的出现是为了防止主工具类的臃肿<br /><br />
                SDK使用业务场景：磁盘，缓存，崩溃，设备，编解码，加解密，文件，图片，键盘，日志，权限，网络，下载<br /><br />
                SDK官网地址：https://github.com/Blankj/AndroidUtilCode<br /><br />
                使用目的/理由：处理图片，设备信息读取，加解密，权限申请<br /><br />

                12. Glide<br /><br />
                SDK类型: 框架  <br /><br />
                SDK描述：一个图片加载库，作者是bumptech。这个库被广泛运用在图片加载处理等相关开源项目中。<br /><br />
                SDK使用业务场景： 图片加载和处理<br /><br />
                SDK官网地址：https://github.com/bumptech/glide<br /><br />
                使用目的/理由：图片加载	<br /><br />

                13. xUtils3<br /><br />
                SDK类型: 框架  <br /><br />
                SDK描述：xUtils 包含了orm, http(s), image, view注解, 但依然很轻量级(251K), 并且特性强大, 方便扩展.<br /><br />
                SDK使用业务场景： 高效稳定的orm工具, 使得http接口实现时更方便的支持cookie和缓存,image:有了http(s)及其下载缓  存的支持, image模块的实现相当的简洁. view注解模块仅仅400多行代码却灵活的支持了各种View注入和事件绑定<br /><br />
                SDK官网地址：https://github.com/wyouflf/xUtils3<br /><br />
                使用目的/理由：https图片加载，view注解<br /><br />

                14. 华为推送<br /><br />
                SDK类型: 推送工具   <br /><br />
                SDK描述：华为推送（Push）是为开发者提供的消息推送平台，建立了从云端到手机端的消息推送通道，让应用可以将最新信息及时通知你的用户，去构筑良好的用户关系，提升用户的感知和活跃度。华为Push支持透传消息、通知栏消息、富媒体消息。<br /><br />
                SDK使用业务场景： 华为设备的消息推送<br /><br />
                SDK需要用户的信息字段：服务器公网IP地址、网络权限（状态）、AAID，消息下发记录，手机用户标识符HMS Core.openId，应用Token,应用Id,包名，SIM运行商类型，通知栏的设置信息。<br /><br />
                SDK官网地址：https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/service-introduction- 0000001050040060<br /><br />
                SDK隐私说明地址：https://consumer.huawei.com/cn/privacy/privacy-policy/<br /><br />
                使用目的/理由：消息推送<br /><br />

                15 小米推送<br /><br />
                SDK类型: 推送工具  <br /><br />
                SDK描述：小米推送（MiPush）是小米公司向开发者提供的消息推送服务，通过云端与客户端之间建立一条稳定、可靠的长连接，为开发者提供向客户端应用实时推送消息的服务，有效地帮助开发者触达用户，提升APP活跃度。<br /><br />
                SDK使用业务场景： 小米设备的消息推送<br /><br />
                SDK需要用户的信息字段：OAID，加密的Android ID，应用包名、版本号、运行状态，网络类型、SIM运行商类型，通知栏的设置信息<br /><br />
                SDK官网地址：https://dev.mi.com/console/doc/detail?pId=863<br /><br />
                SDK隐私说明地址：https://dev.mi.com/console/doc/detail?pId=1822	<br /><br />
                使用目的/理由：消息推送<br /><br />

                16.银联支付<br /><br />
                SDK类型: 支付工具   <br /><br />
                SDK描述：银联手机支付控件是中国银联推出的手机支付产品，可以通过银行卡进行安全的、便捷的即时支付。用户在银联签约商户的手机客户端、手机网站进行付款时，安全支付控件可以保障用户银行卡信息的安全。<br /><br />
                SDK使用业务场景： 主要应用于商户App客户端内集成银联支付控件的支付场景。如果用户已安装云闪付App，商户App调用银联支付控件后会跳转到云闪付App中完成支付，支付完后跳回到商家App内，最后展示支付结果。如果用户未安装云闪付App，商户App内会调起银联支付控件内嵌的收银台完成付款，支付完后展示支付结果。<br /><br />
                SDK需要用户的信息字段：OAID，加密的AndroidId，应用包名、版本号、运行状态，网络类型、SIM运行商类型，通知栏的设置信息<br /><br />
                SDK官网地址：https://open.unionpay.com/tjweb/acproduct/list?apiSvcId=450&index=1<br /><br />
                使用目的/理由：商品支付<br /><br />

                17.有赞云SDK <br /><br />
                SDK类型: 商品平台   <br /><br />
                SDK描述：有赞云AppSDK是为移动端应用打造的电商交易系统，通过SDK便可以在APP内集成有赞提供的交易服务。 <br /><br />
                SDK使用业务场景：  所有具有线上交易需求的行业：包括数码家电、母婴用品、图书音像、教育培训、 酒店旅游、票务/娱乐、等等。<br /><br />
                SDK需要用户的信息字段：DEVICEID/IMSI ，androidID，网络信息<br /><br />
                SDK官网地址：https://dev.mi.com/console/doc/detail?pId=863   <br /><br />
                SDK隐私说明地址：https://x5.tencent.com/tbs/guide/develop.html  <br /><br />
                使用目的/理由：商品销售与展示
                <br /><br />


                十、联系方式<br /><br />

                您可以通过以下方式与我们联系，我们将在30天内答复您的请求：<br /><br />

                1、您可以通过呼呼收音机网站（如www.huhustory.com）/App上提供的在线联系方式/客服系统与我们联系；<br /><br />

                2、您可以联系{this.setName()}的客服电话0571-56716607进行反馈。<br /><br />

                3、我们还设立了专门的个人信息保护团队，您可以通过huhu@hezi.com或者添加微信号呼呼收音机（id：hezihuhu） 联系我们，或者寄信到如下地址：<br /><br />

                浙江省杭州市拱墅区祥盛路12号法务部收（邮编：310012） <br /><br />
                生效日期: 2020年06月15日<br /><br />
            </div>
        </div >);
    }
}